import { Zap, ArrowUpRight } from "lucide-react";
import { CONTACT, WHATSAPP_MSG, AREAS } from "../../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink border-t border-white/10">
      {/* Big CTA */}
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-24 border-b border-white/10">
        <a
          href={`https://wa.me/${CONTACT.phoneRaw}?text=${WHATSAPP_MSG}`}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-cta"
          className="group block"
        >
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-coral">/ Vamos conversar</span>
          <h2 className="mt-4 font-display font-extrabold tracking-tighter text-white text-[13vw] lg:text-[8rem] leading-[0.9] flex flex-wrap items-center gap-4">
            Fale conosco
            <ArrowUpRight className="w-[10vw] h-[10vw] lg:w-28 lg:h-28 text-coral transition-transform duration-500 group-hover:translate-x-3 group-hover:-translate-y-3" strokeWidth={1.5} />
          </h2>
          <p className="mt-4 font-display font-bold text-2xl sm:text-3xl text-white/80">{CONTACT.phone}</p>
        </a>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center w-9 h-9 bg-coral text-white"><Zap size={18} strokeWidth={2.5} /></span>
            <span className="font-display font-extrabold tracking-tight text-white text-lg">
              TOTAL<span className="text-coral">.</span> Engenharia & Serviços
            </span>
          </div>
          <p className="mt-5 text-muted-fg text-sm leading-relaxed max-w-sm">
            Engenharia elétrica especializada em condomínios. Segurança, eficiência e
            valorização do patrimônio com responsabilidade técnica.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-[10px] uppercase tracking-widest text-muted-fg mb-4">Atuação</h4>
          <ul className="space-y-2">
            {AREAS.slice(0, 5).map((a) => (
              <li key={a} className="text-white/80 text-sm">{a}</li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono text-[10px] uppercase tracking-widest text-muted-fg mb-4">Contato</h4>
          <ul className="space-y-2 text-sm">
            <li><a href={`tel:+${CONTACT.phoneRaw}`} className="text-white/80 hover:text-coral transition-colors">{CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="text-white/80 hover:text-coral transition-colors break-all">{CONTACT.email}</a></li>
            <li><a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="text-white/80 hover:text-coral transition-colors">@{CONTACT.instagram}</a></li>
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[11px] text-muted-fg">© {new Date().getFullYear()} Total Engenharia & Serviços. Todos os direitos reservados.</p>
        <p className="font-mono text-[11px] text-muted-fg">Registrada no CREA-SP · ART em todos os serviços</p>
      </div>
    </footer>
  );
}
